<template>
  <el-dialog
    title="详细参数"
    :visible.sync="dialogVisible"
    :before-close="handleClose"
    width="600px"
    class="upload-box"
    :class="{ show: dialogVisible }"
  >
    <el-table
      :data="datailData"
      border
      height="400"
      ref="table"
      size="small"
      :header-cell-style="{ background: '#f9f9f9' }"
    >
      <el-table-column
        type="index"
        width="50"
        :label="$t('product.id')"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="attributeItemName"
        header-align="center"
        align="center"
        label="属性名称"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="attributeValueName"
        header-align="center"
        align="center"
        label="属性值"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <template v-if="editable && scope.row.editable">
            <template v-if="!scope.row.canEdit">
              {{ scope.row.attributeValueName || "-" }}
              <el-button
                size="mini"
                type="text"
                icon="el-icon-edit"
                @click="openEdit(scope.row)"
              ></el-button>
            </template>
            <template v-else>
              <el-input
                size="small"
                maxlength="255"
                placeholder="手动录入"
                style="width: calc(100% - 40px)"
                v-model.trim="scope.row.tempValue"
              />
              <el-button
                size="mini"
                type="text"
                icon="el-icon-check"
                @click="editManualMatch(scope.row)"
              ></el-button>
              <el-button
                size="mini"
                type="text"
                icon="el-icon-close"
                @click="scope.row.canEdit = false"
              ></el-button>
            </template>
          </template>
          <template v-else>{{ scope.row.attributeValueName || "-" }}</template>
        </template>
      </el-table-column>
    </el-table>
    <template #footer>
      <el-button type="primary" size="small" @click="handleClose"
        >确 定</el-button
      >
    </template>
  </el-dialog>
</template>
<script>
export default {
  name: 'info',
  components: {},
  props: {
    manualAttributeValueList: {
      type: Array,
      default: () => []
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    // 参数是否可编辑
    editable: {
      type: Boolean,
      default: false
    },
    // 行数据
    datailDatas: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.datailData = this.datailDatas
        // 判断是否可编辑
        if (this.editable) {
          this.datailData.forEach((item) => {
            // 是否为可编辑状态
            this.$set(item, 'canEdit', false)
            // 赋值一个暂存字段
            this.$set(item, 'tempValue', item.attributeValueName)
            // 是否出现编辑按钮,根据他有没有手动录入的属性值id匹配
            if (
              this.manualAttributeValueList.find(
                (zitem) =>
                  zitem.manualAttributeValueId === item.attributeValueId
              )
            ) {
              this.$set(item, 'editable', true)
            } else {
              this.$set(item, 'editable', false)
            }
          })
        }
        this.$nextTick(() => {
          this.$refs.table && this.$refs.table.doLayout()
        })
      }
    }
  },
  data () {
    return {
      datailData: {}
    }
  },
  mounted () {},
  methods: {
    openEdit (row) {
      row.tempValue = row.attributeValueName
      row.canEdit = true
    },
    editManualMatch (row) {
      if (!row.tempValue) {
        this.$message.warning('请输入')
        return
      }
      row.attributeValueName = row.tempValue
      row.canEdit = false
      this.$emit('updateModel')
    },
    handleClose () {
      this.$emit('update:dialogVisible', false)
    }
  }
}
</script>
<style lang="scss" scoped>
.upload-box {
  transition: transform 0.3s ease-in-out;
  animation: none !important;
  display: block !important;
  overflow: hidden;
  transform: translateX(100%);

  &.show {
    transform: translateX(0);
  }

  &::after {
    content: "";
    display: inline-block;
    vertical-align: middle;
    width: 0;
    height: 100%;
  }

  ::v-deep .el-dialog {
    margin: 0 !important;
    float: right;
    transform: translateY(-50%);
    top: 50%;

    .el-dialog__body {
      max-height: calc(100vh - 114px);
      overflow: auto;
    }
  }
  ::v-deep .el-descriptions-item__container {
    .el-descriptions-item__label {
      align-items: center;
    }
  }
}
</style>
